"use client";

import { Box, Typography, alpha } from "@mui/material";
import { CustomerSupport } from "./CustomerSupport";
import Career from "./Career";
import React, { useLayoutEffect } from "react";
import "./index.css";

const Contact = () => {
  const [selectedItem, setSelectedItem] = React.useState(1);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [activeWidth, setActiveWidth] = React.useState({
    height: 0,
    width: 0,
  });

  const handleItemClick = (itemId: number) => {
    setSelectedItem(itemId);
  };

  const calcWidth = (columns: any) => {
    const elWidth = containerRef.current ? containerRef.current.clientWidth : 0;
    const elHeight = containerRef.current
      ? containerRef.current.clientHeight
      : 0;
    return {
      width: elWidth / columns,
      height: elHeight,
    };
  };

  useLayoutEffect(() => {
    const updateWidth = () => setActiveWidth(calcWidth(2));

    // Set a timeout to delay the initial update
    const timer = setTimeout(() => {
      updateWidth();
    }, 1000);

    // Update on resize
    const handleResize = () => {
      clearTimeout(timer);
      setTimeout(() => {
        updateWidth();
      }, 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box
      component="section"
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        px: { xs: 2, sm: 3 },
        pt: { xs: 2, sm: 3 },
        pb: { xs: 12, sm: 6 },
        width: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 800,
          letterSpacing: "-0.03em",
          color: "#0b1710",
          mb: 0.5,
          fontSize: { xs: "1.35rem", sm: "1.5rem" },
        }}
      >
        Contact us
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2.5, maxWidth: "36rem" }}
      >
        Reach our team for support or explore career opportunities.
      </Typography>
      <Box
        sx={{
          position: "relative",
          p: "5px",
          display: "inline-grid",
          width: "100%",
          maxWidth: 420,
          borderRadius: "999px",
          border: `1px solid ${alpha("#1f7a4d", 0.2)}`,
          boxShadow: "0 8px 24px rgba(15, 23, 17, 0.06)",
          mb: 2,
          bgcolor: alpha("#1f7a4d", 0.04),
        }}
      >
        <Box
          sx={{
            display: "inline-grid",
            gridAutoFlow: "column",
            gridAutoColumns: "1fr",
            gridGap: "5px",
            textAlign: "center",
            position: "relative",
            zIndex: 2,
          }}
          ref={containerRef}
        >
          <Box
            role="button"
            className={`toggle-button-item ${
              selectedItem === 1 ? "active" : ""
            }`}
            onClick={() => handleItemClick(1)}
          >
            Customer Support
          </Box>
          <Box
            role="button"
            className={`toggle-button-item ${
              selectedItem === 2 ? "active" : ""
            }`}
            onClick={() => handleItemClick(2)}
          >
            Career
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: "5px",
            left: "5px",
            zIndex: 1,
            height: "calc(100% - 10px)",
            background:
              "linear-gradient(135deg, #123524 0%, #1f7a4d 55%, #1a6b42 100%)",
            transition: "transform 0.3s ease",
            borderRadius: "999px",
          }}
          style={{
            transform: `translateX(calc(${selectedItem - 1} * ${
              activeWidth.width
            }px))`,
            width: `${activeWidth.width}px`,
            height: `${activeWidth.height}px`,
          }}
        />
      </Box>
      {selectedItem === 1 ? <CustomerSupport /> : ""}
      {selectedItem === 2 ? <Career /> : ""}
    </Box>
  );
};

export default Contact;
